<ng-container *ngIf="component.data$ | async as data">
  <p *ngIf="!isHtml(data.content); else wrapWithDiv" [innerHTML]="data.content"></p>

  <ng-template #wrapWithDiv>
    <div [innerHTML]="data.content | jagaFixAnchor | jagaSafe: 'html'"></div>
  </ng-template>

</ng-container>
